"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VideoIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.972 1A1.972 1.972 0 001 2.972v10.056C1 14.117 1.883 15 2.972 15h10.056A1.972 1.972 0 0015 13.028V2.972A1.972 1.972 0 0013.028 1H2.972zM6.25 6.108c0-.506.548-.823.986-.57l3.278 1.893a.657.657 0 010 1.138l-3.278 1.893a.657.657 0 01-.986-.57V6.108z",
    clipRule: "evenodd"
  })))
});
VideoIcon.displayName = 'VideoIcon';
var _default = exports.default = VideoIcon;